export default (element, data) => {
  const { layout } = data;
  const header = element.querySelector('[data-header-container]');
  const megaMenus = element.querySelectorAll('[data-header-mega-menu]');
  const mobileLinks = element.querySelectorAll('[data-header-mobile-link]');
  const closePanel = new CustomEvent('close-panel:hamburger-panel');
  const hoverLinks = element.querySelectorAll('[data-header-link-hover]');
  const customerLinks = element.querySelectorAll('[data-header-customer-link]');
 
  const updateTabIndex = (menu, value) => {
    const focusableElements = menu.querySelectorAll('a, button, [tabindex]');
    focusableElements.forEach((el) => {
      el.setAttribute('tabindex', value);
    });
  };

  const hideAllMenus = () => {
    megaMenus.forEach((megaMenu) => {
      megaMenu.classList.remove('lg:translate-y-0');
      megaMenu.classList.add('lg:-translate-y-4');
      megaMenu.classList.remove('lg:opacity-100');
      megaMenu.classList.add('lg:opacity-0');
      megaMenu.classList.add('lg:pointer-events-none');
      megaMenu.classList.remove('lg:pointer-events-auto');
      megaMenu.classList.remove('lg:block');
      updateTabIndex(megaMenu, '-1'); 
    });

    hoverLinks.forEach((hoverLink) => {
      hoverLink.classList.add('hidden');
    });
  };

  const changeLinksAttribute = (links,attribute,attributeValue) => {
    links.forEach((link)=>{
      link.setAttribute(attribute,attributeValue)
    })
  }
  
  const initMegaMenus = () => {
    if (layout.isAboveBreakpoint('lg')) {
      const links = header.querySelectorAll('[data-header-link]');

      const handleEscape = (e) => {
        if (e.code === 'Escape') {
          const activeMenu = document.activeElement.closest('[data-parent-link]');
          if (activeMenu) {
            const parentLink = header.querySelector(
              `[data-header-link="${activeMenu.dataset.parentLink}"]`
            );

            hideAllMenus();
            if (parentLink) {
              parentLink.nextElementSibling?.focus();
              parentLink.nextElementSibling?.setAttribute('aria-expanded', 'false');
            }
          }
        }
      };

      const handleArrowNavigation = (e) => {
        if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
          e.preventDefault();
          const focusableElements = Array.from(
            e.target.closest('[data-parent-link]')?.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])') || []
          );

          const currentIndex = focusableElements.
          indexOf(document.activeElement);
          let nextIndex;

          if (e.code === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % focusableElements.length;
          } else if (e.code === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + focusableElements.length) %
             focusableElements.length;
          }

          focusableElements[nextIndex]?.focus();
        }
      };

      const menuEvents = (e, link) => {
        e.stopPropagation();
        if (e.type === 'keydown' && e.code !== 'ArrowDown' && e.code !== 'Enter') return;
        megaMenus.forEach((menu) => {
          const linkParent = link.dataset.headerLink;
          const megaParent = menu.dataset.parentLink;
          const hoverLink = link.querySelector('[data-header-link-hover]');
         
          if (linkParent === megaParent) {
            link.nextElementSibling?.setAttribute('aria-expanded', 'true');
            hideAllMenus();

            setTimeout(() => {
              menu.classList.add('lg:block')
            }, 10);

            setTimeout(() => {
              menu.classList.remove('lg:-translate-y-4');
              menu.classList.add('lg:translate-y-0');
              menu.classList.remove('lg:opacity-0');
              menu.classList.add('lg:opacity-100');
              menu.classList.remove('lg:pointer-events-none');
              menu.classList.add('lg:pointer-events-auto');
              updateTabIndex(menu, '0'); 

              if (hoverLink) hoverLink.classList.remove('hidden');

              const firstFocusable = menu.querySelector('a');

              if (firstFocusable) {
                firstFocusable.focus();
              }

              menu.addEventListener('keydown', handleArrowNavigation);
            }, 30);

            menu.addEventListener('mouseleave', () => {
              hideAllMenus();
            });
          } else {
            hideAllMenus();
          }
        });
      };

      document.addEventListener('keydown', handleEscape);

      links.forEach((link) => {
        link.addEventListener('mouseenter', (e) => {
          menuEvents(e, link);
        });
        link.nextElementSibling?.addEventListener('click', (e) => {
          menuEvents(e, link);
        });
        link.nextElementSibling?.addEventListener('keydown', (e) => {
          menuEvents(e, link);
        });
      });
    }
  };

  const focusHandle = (focusedItem, e) => {
    if (!e.shiftKey && e.key === 'Tab') {
      e.preventDefault();
      focusedItem.focus();
    } 
};

const backFocusHandle = (focusedItem, e) => {
    if (e.shiftKey && e.key === 'Tab') {
      e.preventDefault();
      focusedItem.focus();
    } 
};

  const initHamburgerMenu = () => {
    const hamburgerMenu = element.querySelector('[data-hamburger-menu]');
    const closeHamburger = element.querySelector('[data-hamburger-menu-close]');
    const homeHamburger = element.querySelector('[data-hamburger-home]');
    const hamburgerContainer = element.querySelector('[data-hamburger-container]');
    const hamburgerLinks = hamburgerContainer.querySelectorAll('a');
    const lastHamburgerLink = hamburgerLinks[hamburgerLinks.length - 1];

    homeHamburger.addEventListener('keydown',(e)=>{
      backFocusHandle(lastHamburgerLink,e)
    })

    lastHamburgerLink.addEventListener('keydown',(e)=>{
      focusHandle(homeHamburger,e)
    })

    closeHamburger.addEventListener('keydown',(e)=>{
      backFocusHandle(homeHamburger,e)
    })

    hamburgerMenu.addEventListener('click', () => {
      const openPanel = new CustomEvent('open-panel:hamburger-panel');
      document.dispatchEvent(openPanel);
      closeHamburger.setAttribute('tabindex',0)
      homeHamburger.setAttribute('tabindex',0)
      changeLinksAttribute(mobileLinks,'tabindex',0)
      changeLinksAttribute(customerLinks,'tabindex',0)
      closeHamburger.focus();
    });

    closeHamburger.addEventListener('click', (e) => {
      e.stopPropagation();
      document.dispatchEvent(closePanel);
      closeHamburger.setAttribute('tabindex','-1')
      homeHamburger.setAttribute('tabindex','-1')
      changeLinksAttribute(mobileLinks,'tabindex','-1')
      changeLinksAttribute(customerLinks,'tabindex','-1')
      hamburgerMenu.focus();
    })

    const initMobileMegaMenus = () => {
      let currentOpenLink = null;

      megaMenus.forEach((menu) => {
        const menuTitle = menu.querySelector('[data-header-mega-menu-mobile-title]');
        const closeSubmenu = menuTitle?.querySelector('[data-header-close-submenu]');
        const backSubmenu = menuTitle?.querySelector('[data-header-submenu-back]');
        const menuLinks = menu.querySelectorAll('a');
        const lastLink = menuLinks[menuLinks.length - 1];
        const firstLink = menuLinks[0];

        const hideSubmenu = () => {
          menu.classList.add('translate-x-full');
          menu.classList.add('opacity-0');
          updateTabIndex(menu, '-1'); 
          setTimeout(() => {
            menu.classList.add('hidden');
            if (currentOpenLink) {
              currentOpenLink.focus();
            }
          }, 300);
        }

        firstLink?.addEventListener('keydown', (e) => {
          backFocusHandle(lastLink, e);
        })

        lastLink?.addEventListener('keydown', (e) => {
          focusHandle(firstLink, e);
        })

        if (backSubmenu) {
          backSubmenu.addEventListener('click', () => {
            hideSubmenu();
          });
          
          backSubmenu.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              hideSubmenu();
            } else {
              backFocusHandle(lastLink, e);
            }
          });
        }

        if (closeSubmenu) {
          closeSubmenu.addEventListener('click', (e) => {
            hideSubmenu();
            e.stopPropagation();
            document.dispatchEvent(closePanel);
          });

          closeSubmenu.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              hideSubmenu();
              e.stopPropagation();
              document.dispatchEvent(closePanel);
            } else {
              backFocusHandle(backSubmenu, e);
            }
          });

        }
      });

      const showMegaMenu = (link) => {
        currentOpenLink = link;
        const linkParent = link.dataset.headerMobileLink;
        megaMenus.forEach((menu) => {
          const megaParent = menu.dataset.parentLink;
          if (linkParent === megaParent) {
            menu.classList.remove('hidden');
            const backButton = menu.querySelector('[data-header-submenu-back]');
            if (backButton) {
              backButton.dataset.activeLink = link.id;
            }
            menu.querySelector('[data-header-close-submenu]').focus();
            setTimeout(() => {
              menu.classList.remove('translate-x-full');
              menu.classList.remove('opacity-0');
              updateTabIndex(menu, '0'); 
            },100)
          }
        });
      }

      mobileLinks.forEach((link) => {
        link.addEventListener('click', () => {
          showMegaMenu(link);
        });

        link.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            showMegaMenu(link);
          }
        });
        
      });
    };

    initMobileMegaMenus();
  };

  const initSearchPanel = () => {
    document.querySelectorAll('[data-open-search]').forEach((el) => {
      el.addEventListener('click', () => {
        document.dispatchEvent(
          new CustomEvent('open-panel:search-panel')
        );
      });
    });

    document.querySelectorAll('[data-close-search]').forEach((el) => {
      el.addEventListener('click', () => {
        document.dispatchEvent(
          new CustomEvent('close-panel:search-panel')
        );
      });
    });
  };

  const initStickyHeader = () => {
    if (window.innerWidth > 320) return;
  
    const stickyHeader = element.closest('[data-target="full-header"]');
    if (!stickyHeader) return;
  
    let lastScrollTop = 0;
    const handleScroll = () => {
      const currentScroll = window.pageYOffset || 
        document.documentElement.scrollTop;
      if (currentScroll > lastScrollTop) {
        stickyHeader.classList.remove('sticky');
      } else {
        stickyHeader.classList.add('sticky');
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };
  
    window.addEventListener('scroll', handleScroll);
  };
  
  initMegaMenus();
  initHamburgerMenu();
  initSearchPanel(); 
  initStickyHeader();
  window.addEventListener('resize', initStickyHeader);
  
};
